import { SaveButton } from "components/Buttons"
import React, { useRef, useState, useEffect } from "react"
import { Card, CardBody, Row, Col, CardImg, CardFooter } from "reactstrap"
import {
  deleteLandingMedia,
  deleteMediaGalleryItem,
  getLandingGallery,
  getMediaGallery,
  getMediaGalleryUsers,
  resetMediaGallery,
  uploadEventMedia,
  uploadLandingMedia,
} from "store/actions"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { getFileBlob, getFileBytes } from "utils"
import { IMAGES, URL_PATHS } from "constants/index"
import MediaCaption from "./mediaCaption"
import { Link, generatePath } from "react-router-dom"
import Modal from "./Modal"
import { saveAs } from "file-saver";

const Media = props => {
  useEffect(() => {
    if (props?.selectedEvent) {
      props.getMediaGallery({
        event_id: props.selectedEvent.id,
        menu_item_id: props?.feature?.id,
      })
    } else {
      props?.getLandingGallery({ menu_item_id: props?.feature?.id })
    }
    return () => {
      props.resetMediaGallery()
    }
  }, [])

  const mediaFileRef = useRef(null)
  const [selectedItemsList, setSelectedItemsList] = useState([])

  const handleFileUpload = async event => {
    const files = event.target.files
    const image = []
    const video = []
    for (const file of files) {
      const fileType = file?.type?.split("/")[0]
      const response = await getFileBytes(file)
      if (fileType === "image") {
        image.push(getFileBlob(response))
      }
      if (fileType === "video") {
        video.push(getFileBlob(response))
      }
    }
    if (!props?.selectedEvent) {
      props.uploadLandingMedia({
        imageParams: {
          vendor_id: props.vendorId,
          user_id: props.userId,
          files: image,
        },
        videoParams: {
          vendor_id: props.vendorId,
          user_id: props.userId,
          files: video,
        },
        featureParams: {
          menu_item_id: props?.feature?.id,
          vendor_id: props.vendorId,
        },
      })
    } else {
      props.uploadEventMedia({
        imageParams: {
          vendor_id: props.vendorId,
          add_points: true,
          menu_item_id: props?.feature?.id,
          files: image,
        },
        videoParams: {
          vendor_id: props.vendorId,
          add_points: true,
          menu_item_id: props?.feature?.id,
          files: video,
        },
        notificationParams: {
          event_id: props.selectedEvent.id,
          menu_item_id: props?.feature?.id,
          user_id: props.userId,
          vendor_id: props.vendorId,
        },
      })
    }
  }

  const selectHandler = item => {
    const index = selectedItemsList.indexOf(item)
    if (index === -1) {
      setSelectedItemsList([...selectedItemsList, item])
    } else {
      let newList = [...selectedItemsList]
      newList.splice(index, 1)
      setSelectedItemsList(newList)
    }
  }

  const handleSelectAll = () => {
    if (props.mediaGallery.length !== selectedItemsList.length) {
      setSelectedItemsList(props.mediaGallery.map(img => img.id))
    } else {
      setSelectedItemsList([])
    }
  }

  const downloadHandler = async () => {
    if (selectedItemsList?.length === 1) {
      const item = props?.mediaGallery?.find(
        x => x?.id === selectedItemsList[0]
      )

      fetch(item?.file?.url)
        .then(response => {
          if (!response.ok) {
            throw new Error("Network response was not ok")
          }
          return response.blob()
        })
        .then(imageBlob => {
          const blobUrl = URL.createObjectURL(imageBlob)
          const a = document.createElement("a")
          a.href = blobUrl
          a.download = "image_1.jpg"
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(blobUrl) // Free up memory
        })
        .catch(error => {
          console.error("There was a problem with the fetch operation:", error)
        })
      // fetch(item?.file?.url).then(response => {
      //   response?.blob().then(imageBlob => {
      //     saveAs(URL.createObjectURL(imageBlob), `${item.file.name}`)
      //   })
      // })
    } else {
      var zip = require("jszip")()
      for (const item of props.mediaGallery) {
        if (selectedItemsList.includes(item.id)) {
          const response = await fetch(item.file.url)
          if (!response.ok) {
            throw new Error(`Failed to fetch image: ${response.statusText}`)
          }
          const arrayBuffer = await response.arrayBuffer()
          const contentType = response.headers.get("content-type")
          const fileExtension = contentType
            ? contentType.replace("image/", "")
            : "png"
          zip.file(`${!!item.file.name ?  item.file.name : `image_${Math.floor(Math.random() * 1000000)}`}.${fileExtension}`, arrayBuffer)
          
        }
      }
      const mediaZip = await zip.generateAsync({ type: "blob" })
      saveAs(mediaZip, "media.zip")
    }
  }

  const [isVisible, setIsVisible] = useState(false)

  // Handle delete events
  const deleteHandler = () => {
    if (!props?.selectedEvent) {
      props.deleteLandingMedia({
        data: { ids: selectedItemsList },
        callback: () => {
          setIsVisible(false)
          setSelectedItemsList([])
        },
      })
    } else {
      props.deleteMediagalleryItem({
        data: {
          event_id: props.selectedEvent.id,
          ids: selectedItemsList,
        },
        callback: () => {
          setIsVisible(false)
          setSelectedItemsList([])
        },
      })
    }
  }

  // just handling the delte modal
  const handleDeleteModal = event => {
    setIsVisible(true)
  }

  return (
    <React.Fragment>
      {isVisible && (
        <Modal
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          deleteHandler={deleteHandler}
          selectedMedia={selectedItemsList}
          deleteLoading={props?.deleteLoading}
        />
      )}
      <Card>
        <CardBody>
          <Row>
            <Col>
              <h3>{props.feature.label}</h3>
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                onClick={() => {
                  mediaFileRef.current.click()
                }}
                content="Add Media"
                fullWidth={true}
              />
            </Col>
            {!!props?.selectedEvent && (
              <Col xs="auto">
                <Link
                  to={generatePath(URL_PATHS.FLAGGED_CONTENT, {
                    vendor_id: props?.vendorId,
                    event_id: props?.selectedEvent?.id,
                  })}
                >
                  <SaveButton
                    type="button"
                    color="danger"
                    onClick={() => {}}
                    fullWidth={true}
                    content="Flagged Content"
                  />
                </Link>
              </Col>
            )}
          </Row>
          {props.mediaGallery &&
            props.mediaGallery.length > 0 &&
            props.mediaGalleryUsers && (
              <>
                <Row className="d-flex justify-content-end my-3">
                  <Col xs={"auto"}>
                    <SaveButton
                      type="button"
                      onClick={handleSelectAll}
                      fullWidth={true}
                      color={
                        props.mediaGallery.length !== selectedItemsList.length
                          ? "success"
                          : "danger"
                      }
                      content={
                        props.mediaGallery.length !== selectedItemsList.length
                          ? "Select All"
                          : "Deselect All"
                      }
                    />
                  </Col>
                  <Col xs={"auto"} className="d-flex justify-content-end">
                    <i
                      className="bx bx-sm bxs-download mx-4"
                      style={{
                        backgroundColor:
                          selectedItemsList.length === 0
                            ? "lightgray"
                            : "#34c38f",
                        cursor: selectedItemsList.length > 0 && "pointer",
                        padding: "5px",
                      }}
                      onClick={
                        selectedItemsList.length > 0
                          ? downloadHandler
                          : () => {}
                      }
                    />
                    <i
                      className="bx bx-sm bxs-trash"
                      style={{
                        backgroundColor:
                          selectedItemsList.length === 0
                            ? "lightgray"
                            : "#34c38f",
                        cursor: selectedItemsList.length > 0 && "pointer",
                        padding: "5px",
                      }}
                      // onClick={
                      //   selectedItemsList.length > 0 ? deleteHandler : () => { }
                      // }
                      onClick={
                        selectedItemsList.length > 0 ? handleDeleteModal : null
                      }
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-center">
                  {props.mediaGallery.map(file => (
                    <Col
                      xl={3}
                      md={4}
                      sm={6}
                      className="my-2"
                      key={file.id}
                      style={{ minWidth: "220px" }}
                    >
                      <Card
                        style={{
                          border: selectedItemsList.includes(file.id)
                            ? "2px solid red"
                            : "1px solid silver",
                          padding: "5px",
                          height: "100%",
                        }}
                        onClick={() => selectHandler(file.id)}
                      >
                        <CardBody className="p-0 align-self-center d-flex align-items-center">
                          {file?.file?.type === "image" ? (
                            <img
                              src={file?.file?.url || ""}
                              className="rounded avatar-xl"
                              style={{ blockSize: "auto" }}
                            />
                          ) : (
                            <video
                              style={{ blockSize: "auto", maxWidth: "100%" }}
                              className="rounded avatar-xl"
                              controls
                              src={file?.file?.url || ""}
                            ></video>
                          )}
                        </CardBody>
                        <CardFooter
                          style={{
                            backgroundColor: "WhiteSmoke",
                            padding: "5px",
                          }}
                        >
                          <Row>
                            <Col>
                              <CardImg
                                src={
                                  props.mediaGalleryUsers[file.file.user_id]
                                    ?.profile_pic?.file?.url ||
                                  IMAGES.PROFILE_PLACEHOLDER
                                }
                                className="rounded-circle avatar-xs mx-1"
                              />
                              {
                                props.mediaGalleryUsers[file.file.user_id]
                                  ?.display_name
                              }
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              className="d-flex justify-content-end"
                              style={{ alignItems: "center" }}
                            >
                              <span>
                                <i
                                  className="bx bx-sm bx-heart"
                                  style={{ paddingRight: "5px" }}
                                />
                              </span>
                              <span>{file.likes_count} Likes </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <MediaCaption
                                initialCaption={file?.caption || ""}
                                eventId={file?.event_id}
                                galleryId={file?.id}
                                vendorId={props?.vendorId}
                              />
                            </Col>
                          </Row>
                        </CardFooter>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </>
            )}
          {props.mediaGallery?.length === 0 && (
            <Row className="mt-5" style={{ textAlign: "center" }}>
              <h6>No Media Items</h6>
            </Row>
          )}
        </CardBody>
      </Card>
      <input
        ref={mediaFileRef}
        onChange={handleFileUpload}
        type="file"
        accept="image/*, video/*"
        className="d-none"
        multiple={true}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  mediaGallery: state.MediaGallery.mediaGallery,
  mediaGalleryUsers: state.MediaGallery.mediaGalleryUsers,
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  deleteLoading: state.MediaGallery.deleteLoading,
})

const mapDispatchToProps = dispatch => ({
  getMediaGallery: values => dispatch(getMediaGallery(values)),
  getMediaGalleryUsers: values => dispatch(getMediaGalleryUsers(values)),
  resetMediaGallery: () => dispatch(resetMediaGallery()),
  deleteMediagalleryItem: values => dispatch(deleteMediaGalleryItem(values)),
  getLandingGallery: values => dispatch(getLandingGallery(values)),
  uploadEventMedia: values => dispatch(uploadEventMedia(values)),
  uploadLandingMedia: values => dispatch(uploadLandingMedia(values)),
  deleteLandingMedia: values => dispatch(deleteLandingMedia(values)),
})

Media.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(Media)
